import { z } from "zod";

export const zNumOption = z
  .object({
    value: z.number(),
    label: z.string(),
  })
  .describe(
    "Комбинация данных для одного значения справочника (в котором используются числовые значения)",
  );
export type ZNumOption = z.infer<typeof zNumOption>;

export const zStrOption = z
  .object({
    value: z.string(),
    label: z.string(),
  })
  .describe(
    "Комбинация данных для одного значения справочника (в котором используются строковые значения)",
  );
export type ZStrOption = z.infer<typeof zStrOption>;

export const zOptions = zNumOption.or(zStrOption).array();

export const zAttrValueString = z.object({
  type: z.literal("string"),
  value: z.string(),
});

export const zAttrValueNumber = z.object({
  type: z.literal("number"),
  value: z.number().nullable(),
});

export const zAttrValueBool = z.object({
  type: z.literal("bool"),
  value: z.boolean(),
});

export const zAttrValueNumOption = z.object({
  type: z.literal("numOption"),
  value: zNumOption,
});

export const zAttrValueStrOption = z.object({
  type: z.literal("strOption"),
  value: zStrOption,
});

export type ZRecord = ZDataNode[];
export const zRecord: z.ZodType<ZRecord> = z
  .lazy(() => zDataNode.array())
  .describe(
    "Запись является списком узлов данных. Является типом данных, которые загружаются в форму (и выгружаются из неё при сабмите)",
  );

export const zAttrValueRecord = z.object({
  type: z.literal("record"),
  value: zRecord,
});

export const zAttrValueRecordArray = z
  .object({
    type: z.literal("recordArray"),
    value: zRecord.array(),
  })
  .describe("Сложный тип - список записей");

export const zAttrValue = z
  .discriminatedUnion("type", [
    zAttrValueString,
    zAttrValueNumber,
    zAttrValueBool,
    zAttrValueStrOption,
    zAttrValueRecord,
    zAttrValueRecordArray,
  ])
  .describe(
    "Обобщённое значение состоит из типа (type) и конкретного значения (value), которое зависит от типа ",
  );
export type ZAttrValue = z.infer<typeof zAttrValue>;

export const zDataNode = zAttrValue
  .and(z.object({ name: z.string() }))
  .describe("Узел данных = имя + значение");
export type ZDataNode = z.infer<typeof zDataNode>;

export const dataNode2Value = (node: ZDataNode): ZAttrValue => {
  const { name: _, ...rest } = node;
  return rest;
};
